import React from "react"
import { FastField, useFormikContext } from "formik"

import IntlTelInput from "react-intl-tel-input"
import "react-intl-tel-input/dist/main.css"

import FormError from "../../../formError"

//       registration_date: "",
//       email: "",
//       phone: "",

const BusinessInfo = () => {
  const { errors, touched, values, setFieldValue } = useFormikContext()
  return (
    <>
      <div className="form-row">
        <div className="form-group col-md-12">
          <label htmlFor="company_name">
            {" "}
            Full name of registered business or company
          </label>
          <FastField
            type="text"
            className="form-control"
            id="company_name"
            name="company_name"
          />

          <FormError
            touched={touched.company_name}
            message={errors.company_name}
          />
        </div>
      </div>

      <div className="form-row">
        <div className="form-group col-md-12">
          <label htmlFor="proprietor_name"> Full name of Proprietor</label>
          <FastField
            type="text"
            className="form-control"
            id="proprietor_name"
            name="proprietor_name"
          />

          <FormError
            touched={touched.proprietor_name}
            message={errors.proprietor_name}
          />
        </div>
      </div>

      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="rc_number">BN/RC Number</label>
          <FastField
            className="form-control"
            id="rc_number"
            name="rc_number"
            placeholder=""
          />
          <label
            htmlFor="rc_number"
            className="text-muted font-weight-light mt-2"
          >
            Example - BN1234567 or RC1234567
          </label>

          <FormError touched={touched.rc_number} message={errors.rc_number} />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="registration_date">Company Registration Date</label>
          <FastField
            className="form-control"
            id="registration_date"
            name="registration_date"
            placeholder=""
            type="date"
          />

          <FormError
            touched={touched.registration_date}
            message={errors.registration_date}
          />
        </div>
      </div>

      <div className="form-row justify-between">
        <div className="form-group col-md-5">
          <label htmlFor="email">Valid Email Address</label>
          <FastField className="form-control" id="email" name="email" />

          <FormError touched={touched.email} message={errors.email} />
        </div>

        <div className="form-group col-md-5">
          <label htmlFor="phone">Phone Number</label>

          <IntlTelInput
            inputClassName="form-control"
            defaultCountry="ng"
            id="phone"
            fieldName="phone"
            autoComplete="tel"
            onPhoneNumberChange={(fullnumber, newNumber) => {
              setFieldValue("phone", newNumber)
            }}
            value={values.phone}
            placeholder="XXXX XXXX XXX"
          />

          <FormError touched={touched.phone} message={errors.phone} />
        </div>
      </div>
    </>
  )
}
export default BusinessInfo
